var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketGradienticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.0005L18 24.0005M24 30.0005C26.7937 28.938 29.4738 27.5979 32 26.0005M24 30.0005V40.0005C24 40.0005 30.06 38.9005 32 36.0005C34.16 32.7605 32 26.0005 32 26.0005M18 24.0005C19.0643 21.2394 20.4044 18.5926 22 16.1005C24.3304 12.3745 27.5752 9.30659 31.426 7.18868C35.2768 5.07076 39.6053 3.97324 44 4.0005C44 9.4405 42.44 19.0005 32 26.0005M18 24.0005H8C8 24.0005 9.1 17.9405 12 16.0005C15.24 13.8405 22 16.0005 22 16.0005M9 33.0005C6 35.5205 5 43.0005 5 43.0005C5 43.0005 12.48 42.0005 15 39.0005C16.42 37.3205 16.4 34.7405 14.82 33.1805C14.0426 32.4385 13.0186 32.0098 11.9445 31.9765C10.8703 31.9433 9.82175 32.308 9 33.0005Z",
    stroke: "url(#paint0_linear_2280_17722)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2280_17722",
    x1: 2.95471,
    y1: 43.0005,
    x2: 54.9289,
    y2: 2.09803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246529,
    stopColor: "#FF007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654913,
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketGradienticon);
export default __webpack_public_path__ + "static/media/rocket-gradient.icon.ad116db26e0d1aa375484c9527abd877.svg";
export { ForwardRef as ReactComponent };